module.exports = __webpack_public_path__ + "static/8food-cb0a3e562ee2d9762d61a21c1c6d4944.png";